import { isArray } from 'util';
import { mapCollection, sortByString } from '../../utils/collection.utils';
import { SaleOrderDepartureSerialNumber } from '../sale-order-departure-serial-number';

export class SaleOrderDepartureSerialNumberBuilder {

  static fromJson(json): SaleOrderDepartureSerialNumber {
    return (json) ? new SaleOrderDepartureSerialNumber(
      json.hash,
      json.serialNumber,
      json.saleOrderLineHash,
      json.saleOrderLineType,
      json.saleOrderLineProductName,
      json.saleOrderLineProductCode,
      json.saleOrderLineProductDescription,
      json.saleOrderLineProductNeedSerialNumber,
      json.saleOrderLineComplementName,
      json.saleOrderLineComplementCode,
      json.saleOrderLineComplementDescription,
      json.saleOrderLineComplementNeedSerialNumber
    ) : null;
  }

  static fromJsonList(list): SaleOrderDepartureSerialNumber[] {
    return (isArray(list)) ? sortByString('serialNumber', mapCollection(SaleOrderDepartureSerialNumberBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-departure-serial-number.builder.ts